"use strict";
exports.__esModule = true;
var PromiseTrackingTable = /** @class */ (function () {
    function PromiseTrackingTable() {
    }
    PromiseTrackingTable.makeColHeader = function (data) {
        var colHeaders = data.map(function (d) {
            return d['x'];
        });
        var years = colHeaders.slice();
        colHeaders.unshift('Dev Adjusted NPV');
        return [colHeaders, years];
    };
    PromiseTrackingTable.makeTableData = function (data, nodeName) {
        var npv = data.map(function (d) {
            return d['y'];
        });
        npv.unshift('Promise: ' + nodeName);
        return npv;
    };
    PromiseTrackingTable.makeForecastTableData = function (data, nodeName, years) {
        var npv = years.map(function (year) {
            for (var i = 0; i < data.length; i++) {
                if (data[i]['x'] == year) {
                    return data[i]['y'];
                }
            }
            return '-';
        });
        npv.unshift('Forecast: ' + nodeName);
        return npv;
    };
    PromiseTrackingTable.generateCsv = function (row) {
        var csv = '';
        for (var i = 0; i < row.length; i++) {
            csv += '"' + row[i] + '",';
        }
        csv += '\n';
        return csv;
    };
    PromiseTrackingTable.downloadCsv = function (tableData, filename, csvFormat, skipSave) {
        var csv = PromiseTrackingTable.generateCsv(tableData.years);
        csv += PromiseTrackingTable.generateCsv(tableData.main);
        csv += PromiseTrackingTable.generateCsv(tableData.forecast);
        if (tableData.sibling) {
            csv += PromiseTrackingTable.generateCsv(tableData.sibling);
            csv += PromiseTrackingTable.generateCsv(tableData.siblingForecast);
        }
        if (csvFormat == 'EU') {
            csv = csv.replace(/,/g, ';');
            csv = csv.replace(/\./g, ',');
        }
        if (!skipSave) {
            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        }
        return csv;
    };
    return PromiseTrackingTable;
}());
exports.PromiseTrackingTable = PromiseTrackingTable;
//# sourceMappingURL=promise-tracking.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/promise-tracking/promise-tracking.logic.js